import React from 'react'

export default function HeadingWithIcon({ txt, headerIcon }) {
  // eslint-disable-next-line react/no-unstable-nested-components
  const IconImage = () => {
    return headerIcon ?? null
  }

  return (
    <div css={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div css={{ display: 'inline-block', marginInlineEnd: '1vw' }}>
        <IconImage />
      </div>
      <span css={{ display: 'inline-block' }}>{txt}</span>
    </div>
  )
}
